import { createSelector } from 'reselect';

const shareData = state => state.documentsData.share;

export const shareDataSelector = createSelector(
    shareData,
    data => data.isOpen
);

export const shareUrlSelector = createSelector(
    shareData,
    (data) => {
        return {
            title: data.title,
            id: data.id,
            documentType: data.documentType,
            publicationFamily: data.publicationFamily,
            shareLinkString: data.shareLinkString
        };
    }
);

export const shareEmailsListSelector = createSelector(
    shareData,
    data => data.emails.map((item) => {
        return {
            ...item,
            isCustom: false
        };
    })
);

export const downloadingFileStateSelector = createSelector(
    state => state.documentsData,
    data => data.downloadingFile
);
